module.exports = __webpack_public_path__ + "static/media/logo_azure_synapse.d595fc28.svg";